export const t = {
  nav: {
    fr: { home: 'Accueil', portfolio: 'Portfolio', contact: 'Contact', inquire: 'Demande Priv\u00E9e', brochure: 'Brochure' },
    en: { home: 'Home', portfolio: 'Portfolio', contact: 'Contact', inquire: 'Private Inquiry', brochure: 'Brochure' }
  },
  hero: {
    fr: {
      overline: 'UN LIEU HORS DU TEMPS',
      title: 'Chalets Gemini 1308',
      subtitle: 'Val de Bagnes \u2014 Suisse',
      cta: "ENTREZ DANS L'EXP\u00C9RIENCE"
    },
    en: {
      overline: 'A PLACE BEYOND TIME',
      title: 'Chalets Gemini 1308',
      subtitle: 'Val de Bagnes \u2014 Switzerland',
      cta: 'ENTER THE EXPERIENCE'
    }
  },
  intro: {
    fr: {
      overline: 'D\u00C9COUVRIR',
      title: "Un lieu d'exception dans les Alpes Suisses",
      text: "Il existe des lieux o\u00F9 l'on se laisse simplement vivre. Des parenth\u00E8ses hors du temps, \u00E0 l'abri du tumulte du monde, o\u00F9 l'on s'abandonne pleinement au moment pr\u00E9sent. Les CHALETS GEMINI 1308 font partie de ces lieux.",
      sub: "Chalets mitoyens haut de gamme disponibles \u00E0 M\u00E9di\u00E8res / Verbier."
    },
    en: {
      overline: 'DISCOVER',
      title: 'An Exceptional Place in the Swiss Alps',
      text: "There are places where one simply lets life unfold. Parentheses outside of time, sheltered from the tumult of the world, where one surrenders fully to the present moment. CHALETS GEMINI 1308 are those places.",
      sub: "High-end terraced chalets available in M\u00E9di\u00E8res / Verbier."
    }
  },
  verbier: {
    fr: {
      overline: 'VERBIER',
      title: "Verbier \u2014 L'\u00C2me des Alpes, Le Luxe \u00E0 l'\u00C9tat Pur",
      paragraphs: [
        "Verbier est de ces lieux rares o\u00F9 l'altitude semble suspendre le temps. Un balcon lumineux pos\u00E9 au c\u0153ur du Valais, o\u00F9 la montagne se d\u00E9ploie comme une \u0153uvre d'art, sculpt\u00E9e par la neige, la lumi\u00E8re et le silence.",
        "Dans cette station mythique, l'hiver prend une dimension nouvelle. Les lignes des pistes dessinent un territoire sans limites, port\u00E9 par l'\u00E9nergie des 4 Vall\u00E9es, l\u00E0 o\u00F9 les montagnes r\u00E9v\u00E8lent leur puissance et leur douceur.",
        "C'est un village vibrant, fait de bois noble et de pierre, o\u00F9 les lumi\u00E8res du soir s'allument comme autant d'\u00E9toiles au creux de la vall\u00E9e.",
        "Lorsque les neiges fondent, Verbier se r\u00E9invente en un \u00E9crin estival. Les sentiers deviennent des chemins d'altitude, les for\u00EAts exhalent leurs parfums de r\u00E9sine, et les panoramas s'\u00E9tirent jusqu'aux g\u00E9ants des Alpes.",
        "Verbier n'est pas une station. Verbier est une exp\u00E9rience. Un art de vivre alpin, incomparable, absolu."
      ]
    },
    en: {
      overline: 'VERBIER',
      title: 'Verbier \u2014 The Soul of the Alps, Luxury in its Pure State',
      paragraphs: [
        "Verbier is one of those rare places where altitude seems to suspend time. A luminous balcony set in the heart of the Valais, where the mountain unfolds like a work of art, sculpted by snow, light and silence.",
        "In this legendary resort, winter takes on a new dimension. The lines of the slopes draw a territory without limits, carried by the energy of the 4 Vall\u00E9es, where mountains reveal their power and their gentleness.",
        "It is a vibrant village, built of noble wood and stone, where evening lights ignite like stars nestled in the valley.",
        "When the snow melts, Verbier reinvents itself as a summer jewel. The trails become high-altitude paths, the forests exhale their resinous perfumes, and the panoramas stretch to the giants of the Alps.",
        "Verbier is not a resort. Verbier is an experience. An alpine art of living, incomparable, absolute."
      ]
    }
  },
  architecture: {
    fr: {
      overline: 'LES CHALETS',
      title: 'Chalets Gemini 1308',
      subtitle: "Con\u00E7us pour un usage en r\u00E9sidence principale, les Chalets Gemini 1308 allient confort, \u00E9l\u00E9gance et authenticit\u00E9 dans un cadre naturel d'exception.",
      price: "4'800'000 CHF",
      lots: '2 lots disponibles',
      specs: [
        { label: 'Surface USPI', value: '~270 m\u00B2' },
        { label: 'S\u00E9jour & Cuisine', value: '~100 m\u00B2' },
        { label: 'Chambres', value: '3 chambres' },
        { label: 'Salles de bains', value: '2 + WC visiteur' },
        { label: 'Bien-\u00EAtre', value: 'Spa, Jacuzzi, Sauna' },
        { label: 'Type', value: 'Chalets mitoyens' },
        { label: 'Label', value: 'Minergie' }
      ],
      features: [
        'Finitions haut de gamme avec mat\u00E9riaux nobles',
        'Label Minergie pour efficacit\u00E9 \u00E9nerg\u00E9tique optimale',
        'Spa privatif avec jacuzzi',
        'Chemin\u00E9e, ascenseur, cave et buanderie',
        'Garage couvert et deux places ext\u00E9rieures',
        'Orientation plein sud avec panorama exceptionnel',
        '\u00C0 5 minutes en voiture du centre de Verbier'
      ]
    },
    en: {
      overline: 'THE CHALETS',
      title: 'Chalets Gemini 1308',
      subtitle: 'Designed as primary residences, the Chalets Gemini 1308 combine comfort, elegance and authenticity in an exceptional natural setting.',
      price: "CHF 4'800'000",
      lots: '2 lots available',
      specs: [
        { label: 'USPI Surface', value: '~270 m\u00B2' },
        { label: 'Living & Kitchen', value: '~100 m\u00B2' },
        { label: 'Bedrooms', value: '3 bedrooms' },
        { label: 'Bathrooms', value: '2 + guest WC' },
        { label: 'Wellness', value: 'Spa, Jacuzzi, Sauna' },
        { label: 'Type', value: 'Terraced chalets' },
        { label: 'Label', value: 'Minergie' }
      ],
      features: [
        'High-end finishes with noble materials',
        'Minergie label for optimal energy efficiency',
        'Private spa with jacuzzi',
        'Fireplace, elevator, cellar and laundry',
        'Covered garage and two outdoor spaces',
        'South-facing with exceptional panoramic views',
        '5 minutes drive from Verbier centre'
      ]
    }
  },
  lifestyle: {
    fr: {
      overline: "L'ART DE VIVRE",
      title: "L'Art de Vivre le Luxe Alpin",
      text: "Une exp\u00E9rience unique alliant \u00E9l\u00E9gance minimaliste et confort absolu, inspir\u00E9e des plus prestigieuses adresses du monde.",
      references: "Dans la lign\u00E9e d'Antar\u00E8s Courchevel, Six Senses, Aman et Ultima Collection.",
      pillars: [
        { title: "Collaboration d'exception", desc: 'Architectes suisses prim\u00E9s et designers internationaux de renom' },
        { title: 'Mat\u00E9riaux nobles', desc: 'Bois suisse s\u00E9culaire, pierre naturelle locale, verre panoramique' },
        { title: 'Int\u00E9rieurs \u00E9pur\u00E9s', desc: 'Volumes g\u00E9n\u00E9reux baign\u00E9s de lumi\u00E8re naturelle, espaces fluides' },
        { title: 'Personnalisation totale', desc: 'Espaces modulables pour une adaptation compl\u00E8te \u00E0 vos d\u00E9sirs' }
      ]
    },
    en: {
      overline: 'THE ART OF LIVING',
      title: 'The Art of Alpine Luxury Living',
      text: "A unique experience combining minimalist elegance and absolute comfort, inspired by the world's most prestigious addresses.",
      references: 'In the lineage of Antar\u00E8s Courchevel, Six Senses, Aman and Ultima Collection.',
      pillars: [
        { title: 'Exceptional collaboration', desc: 'Award-winning Swiss architects and renowned international designers' },
        { title: 'Noble materials', desc: 'Century-old Swiss wood, local natural stone, panoramic glass' },
        { title: 'Refined interiors', desc: 'Generous volumes bathed in natural light, fluid spaces' },
        { title: 'Total customization', desc: 'Modular spaces for complete adaptation to your desires' }
      ]
    }
  },
  wellness: {
    fr: {
      overline: 'BIEN-\u00CATRE',
      title: "L\u00E0 o\u00F9 la chaleur embrasse le silence",
      features: [
        'Spa priv\u00E9 \u2014 Sauna \u2014 Jacuzzi ext\u00E9rieur',
        'Votre sanctuaire en toute saison'
      ]
    },
    en: {
      overline: 'WELLNESS',
      title: 'Where warmth embraces silence',
      features: [
        'Private spa \u2014 Sauna \u2014 Outdoor jacuzzi',
        'Your sanctuary in every season'
      ]
    }
  },
  investor: {
    fr: {
      overline: 'INVESTISSEMENT',
      title: 'Avantages Strat\u00E9giques',
      items: [
        'Fiscalit\u00E9 avantageuse en Suisse et dans le Val de Bagnes',
        'Cadre l\u00E9gal stable et s\u00E9curis\u00E9',
        'Tr\u00E8s peu d\'offre',
        'Demande internationale soutenue',
        'Un investissement patrimonial'
      ],
      text: "Un investissement patrimonial dans un environnement privil\u00E9gi\u00E9 o\u00F9 la valeur ne fait que cro\u00EEtre avec le temps.",
      closing: "Ce n'est pas un achat",
      closingSub: "C'est un h\u00E9ritage"
    },
    en: {
      overline: 'INVESTMENT',
      title: 'Strategic Advantages',
      items: [
        'Favorable taxation in Switzerland and Val de Bagnes',
        'Stable and secure legal framework',
        'Very limited supply',
        'Sustained international demand',
        'A patrimonial investment'
      ],
      text: 'A patrimonial investment in a privileged environment where value only grows over time.',
      closing: 'This is not a purchase',
      closingSub: 'It is a legacy'
    }
  },
  closing: {
    fr: {
      title: 'Luxe. Nature. S\u00E9r\u00E9nit\u00E9.',
      ctaBrochure: 'Demander la Brochure Confidentielle',
      ctaViewing: 'Planifier une Visite Priv\u00E9e'
    },
    en: {
      title: 'Luxury. Nature. Serenity.',
      ctaBrochure: 'Request Confidential Brochure',
      ctaViewing: 'Schedule Private Viewing'
    }
  },
  portfolio: {
    fr: {
      overline: 'PORTFOLIO',
      title: 'Galerie',
      subtitle: 'D\u00E9couvrez chaque d\u00E9tail de cette r\u00E9sidence exceptionnelle',
      all: 'Tout',
      exterior: 'Ext\u00E9rieur',
      interior: 'Int\u00E9rieur'
    },
    en: {
      overline: 'PORTFOLIO',
      title: 'Gallery',
      subtitle: 'Discover every detail of this exceptional residence',
      all: 'All',
      exterior: 'Exterior',
      interior: 'Interior'
    }
  },
  contact: {
    fr: {
      overline: 'CONTACT',
      title: 'Invitation Privée',
      subtitle: 'Pour toute demande confidentielle, notre équipe se tient à votre disposition.',
      name: 'Nom complet',
      email: 'Adresse email',
      phone: 'Téléphone',
      message: 'Votre message',
      requestBrochure: 'Je souhaite recevoir la brochure',
      send: 'Envoyer',
      success: 'Merci. Nous vous contacterons dans les plus brefs délais.',
      directEmail: 'Ou contactez-nous directement :',
      address: 'Chemin de Plampro 32, 1936 Médières / Verbier'
    },
    en: {
      overline: 'CONTACT',
      title: 'Private Invitation',
      subtitle: 'For any confidential inquiry, our team is at your service.',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone',
      message: 'Your message',
      requestBrochure: 'I would like to receive the brochure',
      send: 'Send',
      success: 'Thank you. We will contact you shortly.',
      directEmail: 'Or contact us directly:',
      address: 'Chemin de Plampro 32, 1936 Médières / Verbier, Switzerland'
    }
  },
  brochureModal: {
    fr: {
      title: 'Brochure Confidentielle',
      subtitle: 'Entrez votre email pour recevoir la brochure exclusive des Chalets Gemini 1308.',
      placeholder: 'Votre adresse email',
      namePlaceholder: 'Votre nom (optionnel)',
      cta: 'Recevoir la Brochure',
      success: 'Merci ! La brochure se t\u00E9l\u00E9charge...'
    },
    en: {
      title: 'Confidential Brochure',
      subtitle: 'Enter your email to receive the exclusive Chalets Gemini 1308 brochure.',
      placeholder: 'Your email address',
      namePlaceholder: 'Your name (optional)',
      cta: 'Receive the Brochure',
      success: 'Thank you! The brochure is downloading...'
    }
  },
  footer: {
    fr: { copy: 'Immoconcept Rième. Tous droits réservés.', legal: 'Mentions légales' },
    en: { copy: 'Immoconcept Rième. All rights reserved.', legal: 'Legal notice' }
  }
};
